// ----------------------------------------
import StaffIntroPage from '@/views/staff/2.intro/StaffIntroPage'
// 운영
import AdminOrgPage from '@/views/staff/2.operation/org/AdminOrgPage'
import StaffNcsTrainingPage from '@/views/staff/2.operation/ncstraining/StaffNcsTrainingPage'
import StaffNcsTrainingDetailPage from '@/views/staff/2.operation/ncstraining/StaffNcsTrainingDetailPage'

// 훈련 개설
import StaffOpenTrainingPage from '@/views/staff/2.operation/opentraining/StaffOpenTrainingPage'
import StaffOpenTrainingDetailPage from '@/views/staff/2.operation/opentraining/StaffOpenTrainingDetailPage'
import StaffOpenTrainingIntro from '@/views/staff/2.operation/opentraining/StaffOpenTrainingIntro'
import StaffOpenTrainingStructure from '@/views/staff/2.operation/opentraining/StaffOpenTrainingStructure'
import StaffOpenTrainingPlan from '@/views/staff/2.operation/opentraining/StaffOpenTrainingPlan'
import StaffOpenTrainingPreTest from '@/views/staff/2.operation/opentraining/StaffOpenTrainingPreTest'
import StaffOpenTrainingPefrom from '@/views/staff/2.operation/opentraining/StaffOpenTrainingPefrom'
import StaffOpenTrainingWritingTest from '@/views/staff/2.operation/opentraining/6.writing/StaffOpenTrainingWritingTest'
import StaffOpenTrainingWritingTestEdit from '@/views/staff/2.operation/opentraining/6.writing/StaffOpenTrainingWritingTestEdit'
import StaffOpenTrainingAttitude from '@/views/staff/2.operation/opentraining/7.attitude/StaffOpenTrainingAttitude'
import StaffOpenTrainingAttitudeEdit from '@/views/staff/2.operation/opentraining/7.attitude/StaffOpenTrainingAttitudeEdit'
import StaffOpenTrainingPortfolio from '@/views/staff/2.operation/opentraining/8.portfolio/StaffOpenTrainingPortfolio'
import StaffOpenTrainingPortfolioEdit from '@/views/staff/2.operation/opentraining/8.portfolio/StaffOpenTrainingPortfolioEdit'

// 동의서 관리
import StaffAgreementPage from '@/views/staff/2.operation/agreement/StaffAgreementPage'
import StaffAgreement from '@/views/staff/2.operation/agreement/StaffAgreement'
import StaffAgreementEdit from '@/views/staff/2.operation/agreement/StaffAgreementEdit'

// 평가
import StaffTestPage from '@/views/staff/3.test/StaffTestPage'
import StaffTestSummaryByStudent from '@/views/staff/3.test/StaffTestSummaryByStudent'
import StaffTestSummaryBySubject from '@/views/staff/3.test/StaffTestSummaryBySubject'
import StaffPerformTestView from '@/views/staff/3.test/perform/StaffPerformTestView'
import StaffWritingTestView from '@/views/staff/3.test/writing/StaffWritingTestView'
import StaffAttitudeTestView from '@/views/staff/3.test/attitude/StaffAttitudeTestView'
import StaffPortfolioTestView from '@/views/staff/3.test/portfolio/StaffPortfolioTestView'
import StaffTotalSummary from '@/views/staff/3.test/StaffTotalSummary'

// 회의록
import StaffProceedingPage from '@/views/staff/4.proceeding/StaffProceedingPage'
import StaffProceedingViewPage from '@/views/staff/4.proceeding/StaffProceedingViewPage'
import StaffProceedingEditPage from '@/views/staff/4.proceeding/StaffProceedingEditPage'
// 일지 및 상담
import StaffRegularCounselPage from '@/views/staff/5.log_counsel/StaffRegularCounselPage'
import StaffDailyLogPage from '@/views/staff/5.log_counsel/StaffDailyLogPage'

// import StaffBoardPage from '@/views/staff/4.board/StudentBoardPage'
import StaffTeacherManagePage from '@/views/staff/8.teachers/StaffTeacherManagePage'
import StaffTeacherEdit from '@/views/staff/8.teachers/StaffTeacherEdit'
// 학생관리
import StaffStudentManagePage from '@/views/staff/7.students/StaffStudentManagePage'
import StaffStudentAddPage from '@/views/staff/7.students/StaffStudentAddPage'
import StaffStudentEditPage from '@/views/staff/7.students/StaffStudentEditPage'

// 공지사항
import StaffNotificationPage from '@/views/common/notification/Notification'
// 게시판
import StaffBoardPage from '@/views/common/board/Board'

const routes = [
  { path: '/staff/training_intro', name: 'StaffIntroPage', component: StaffIntroPage },
  { path: '/staff/operation/org', name: 'AdminOrgPage', component: AdminOrgPage },
  { path: '/staff/operation/ncstraining', name: 'StaffNcsTrainingPage', component: StaffNcsTrainingPage },
  { path: '/staff/operation/ncstrainingdetail', name: 'StaffNcsTrainingDetailPage', component: StaffNcsTrainingDetailPage },
  { path: '/staff/operation/opentraining', name: 'StaffOpenTrainingPage', component: StaffOpenTrainingPage },
  {
    path: '/staff/operation/opentraining/detail',
    name: 'StaffOpenTrainingDetailPage',
    component: StaffOpenTrainingDetailPage,
    children: [
      { path: 'intro', name: 'StaffOpenTrainingIntro', component: StaffOpenTrainingIntro },
      { path: 'structure', name: 'StaffOpenTrainingStructure', component: StaffOpenTrainingStructure },
      { path: 'plan', name: 'StaffOpenTrainingPlan', component: StaffOpenTrainingPlan },
      { path: 'pretest', name: 'StaffOpenTrainingPreTest', component: StaffOpenTrainingPreTest },
      { path: 'perform', name: 'StaffOpenTrainingPefrom', component: StaffOpenTrainingPefrom },
      { path: 'writing/list', name: 'StaffOpenTrainingWritingTest', component: StaffOpenTrainingWritingTest },
      { path: 'writing/edit', name: 'StaffOpenTrainingWritingTestEdit', component: StaffOpenTrainingWritingTestEdit },
      { path: 'attitude/list', name: 'StaffOpenTrainingAttitude', component: StaffOpenTrainingAttitude },
      { path: 'attitude/edit', name: 'StaffOpenTrainingAttitudeEdit', component: StaffOpenTrainingAttitudeEdit },
      { path: 'portfolio/list', name: 'StaffOpenTrainingPortfolio', component: StaffOpenTrainingPortfolio },
      { path: 'portfolio/edit', name: 'StaffOpenTrainingPortfolioEdit', component: StaffOpenTrainingPortfolioEdit }
    ]
  },
  { path: '/staff/operation/agreement', name: 'StaffAgreementPage', component: StaffAgreementPage },
  { path: '/staff/operation/agreement/:_id', name: 'StaffAgreement', component: StaffAgreement },
  { path: '/staff/operation/agreement/edit/:_id', name: 'StaffAgreementEdit', component: StaffAgreementEdit },
  {
    path: '/staff/test',
    name: 'StaffTestPage',
    component: StaffTestPage,
    children: [
      { path: 'bystudent', name: 'StaffTestSummaryByStudent', component: StaffTestSummaryByStudent },
      { path: 'bysubject', name: 'StaffTestSummaryBySubject', component: StaffTestSummaryBySubject },
      { path: 'writing/perform', name: 'StaffPerformTestView', component: StaffPerformTestView },
      { path: 'writing/view', name: 'StaffWritingTestView', component: StaffWritingTestView },
      { path: 'attitude/view', name: 'StaffAttitudeTestView', component: StaffAttitudeTestView },
      { path: 'portfolio/view', name: 'StaffPortfolioTestView', component: StaffPortfolioTestView }
    ]
  },
  { path: '/staff/totalsummary', name: 'StaffTotalSummary', component: StaffTotalSummary },

  // 회의록
  {
    path: '/staff/proceeding',
    name: 'StaffProceedingPage',
    component: StaffProceedingPage,
    children: [
      { path: 'view', name: 'StaffProceedingViewPage', component: StaffProceedingViewPage },
      { path: 'edit', name: 'StaffProceedingEditPage', component: StaffProceedingEditPage }
    ]
  },
  // 정기 상담
  { path: '/staff/regularcounsel', name: 'StaffRegularCounselPage', component: StaffRegularCounselPage },
  { path: '/staff/dailylog', name: 'StaffDailyLogPage', component: StaffDailyLogPage },
  // { path: '/staff/regularcounsel', name: 'RegularCounsel', component: RegularCounselPage },
  // { path: '/staff/dailylog', name: 'DailyLog', component: DailyLogPage }

  // { path: '/student/test', name: 'StudentTestPage', component: StudentTestPage },
  // { path: '/student/board', name: 'StudentBoardPage', component: StudentBoardPage }
  { path: '/staff/teachers', name: 'StaffTeacherManagePage', component: StaffTeacherManagePage },
  { path: '/staff/teachers/edit', name: 'StaffTeacherEdit', component: StaffTeacherEdit },
  // 학생 관리
  { path: '/staff/students', name: 'StaffStudentManagePage', component: StaffStudentManagePage },
  { path: '/staff/addstudent', name: 'StaffStudentAddPage', component: StaffStudentAddPage },
  { path: '/staff/editstudent', name: 'StaffStudentEditPage', component: StaffStudentEditPage },
  // 게시판
  { path: '/staff/board', name: 'StaffBoardPage', component: StaffBoardPage },
  // 공지사항
  { path: '/staff/notification', name: 'StaffNotificationPage', component: StaffNotificationPage }
]

export default routes
